import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from "@design-system/components";
import { Trans } from "@lingui/react/macro";
import React from "react";

const DEPRECATED_HOSTNAME = "connect.spirii.dk";
const REPLACEMENT_HOSTNAME = "connect.spirii.com";

function buildReplacementUrl(): string {
  const { pathname, search, hash, protocol } = window.location;
  return `${protocol}//${REPLACEMENT_HOSTNAME}${pathname}${search}${hash}`;
}

interface DomainDeprecationDialogViewProps {
  onRedirect: () => void;
}

/**
 * Presentational variant of the dialog without the hostname gate.
 * Used by Storybook and could be reused in any context where the dialog
 * should be rendered regardless of the current hostname.
 */
function DomainDeprecationDialogView({
  onRedirect,
}: DomainDeprecationDialogViewProps) {
  return (
    <AlertDialog open>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            <Trans>connect.spirii.dk is shutting down</Trans>
          </AlertDialogTitle>
          <AlertDialogDescription>
            <Trans>
              The connect.spirii.dk domain will stop working on 25 May. Switch
              to connect.spirii.com to continue without interruption.
            </Trans>
            <br />
            <Trans>Remember to update any bookmarks.</Trans>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="emphasised" onClick={onRedirect}>
            <Trans>Switch to connect.spirii.com</Trans>
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

function DomainDeprecationDialog() {
  const isDeprecatedDomain = window.location.hostname === DEPRECATED_HOSTNAME;

  if (!isDeprecatedDomain) {
    return null;
  }

  const handleRedirect = () => {
    window.location.href = buildReplacementUrl();
  };

  return <DomainDeprecationDialogView onRedirect={handleRedirect} />;
}

export { DomainDeprecationDialog, DomainDeprecationDialogView };
export type { DomainDeprecationDialogViewProps };
